import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { useTheme, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { compose } from "recompose";
import { showModal } from "../../../redux/actions";
import ExportSubscribersModal from "./ExportSubscribersModal";

const styles = {
  root: {
    background: "black",
  },
  input: {
    color: "white",
    backgroundColor: "rgb(36, 48, 65)",
  },
};

const ExportSubscribersButton = ({ onClick, intl }) => {
  useTheme();

  return (
    <Button variant="contained" color="primary" onClick={() => onClick()}>
      {intl.formatMessage({
        id: "app.subscribers.exportSubscribersButtonLabel",
      })}
    </Button>
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  onClick: () => dispatch(showModal(ExportSubscribersModal)),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
  withStyles(styles),
);

export default enhance(ExportSubscribersButton);
